var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isOpen
    ? _c("modal", {
        attrs: { maxWidth: "745px", maxHeight: "745px" },
        on: { "hide-modal": _vm.hideModal },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "relative w-full" },
                    [
                      _c("div", { staticClass: "header" }, [
                        _c(
                          "h1",
                          { staticClass: "text-2xl mb-0 mt-0 font-semibold" },
                          [_vm._v(_vm._s(_vm.globals.cmModal.title))]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-base mt-0 leading-tight text-blue-dark",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.globals.cmModal.description.replace(
                                  "_quantity_",
                                  _vm.currentQuantity
                                )
                              )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm._l(_vm.fullCMList, function (cm) {
                        return _c(
                          "div",
                          { key: cm, staticClass: "product-wrapper" },
                          [
                            (cm.key === "CM31" && _vm.showCM31) ||
                            (cm.key === "CM32" && _vm.showCM32)
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-wrap justify-center",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "image-wrapper md:w-1/2 flex justify-center align-start",
                                      },
                                      [
                                        _c("img", {
                                          attrs: { src: cm.image[0] },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "content-wrapper md:w-1/2",
                                      },
                                      [
                                        _c(
                                          "h1",
                                          {
                                            staticClass:
                                              "text-xl mb-0 mt-0 font-semibold",
                                          },
                                          [_vm._v(_vm._s(cm.name))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-lg mt-0 leading-tight text-blue-dark",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.currencySymbol) +
                                                _vm._s(
                                                  _vm.calculateTotalPrice(
                                                    cm.offerings[
                                                      cm.defaultOffering
                                                    ].salesPrice
                                                  )
                                                ) +
                                                "/" +
                                                _vm._s(
                                                  cm.offerings[
                                                    cm.defaultOffering
                                                  ].defaultPaymentTerm
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-base mt-1 text-blue-dark",
                                          },
                                          [_vm._v(_vm._s(cm.brief))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "quantity-info-container mt-1 flex justify-start items-center",
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "text-base font-semibold mr-1 text-blue-dark mt-0 ml-0",
                                              },
                                              [_vm._v("Select Quantity")]
                                            ),
                                            _vm._v(" "),
                                            _c("QuantityToggle", {
                                              ref: "selectedQuantity",
                                              refInFor: true,
                                              attrs: {
                                                max:
                                                  _vm.currentQuantity -
                                                  (cm.key === "CM31"
                                                    ? _vm.CM32Quantity
                                                    : _vm.CM31Quantity),
                                                min: 0,
                                                default: 0,
                                                productKeyOverride: cm.key,
                                              },
                                              on: {
                                                setProductQuantity: function (
                                                  $event
                                                ) {
                                                  return _vm.setQuantity(
                                                    $event,
                                                    cm.key
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("hr"),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "footer-wrapper flex justify-end pt-1 md:pt-2 md:pr-3",
                        },
                        [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "text-lg md:text-xl blue-text mr-1 cursor-pointer",
                              on: { click: _vm.handleSkipAddOnsClick },
                            },
                            [_vm._v("Skip add-ons")]
                          ),
                          _vm._v(" "),
                          _c("vButton", {
                            attrs: {
                              position: "center",
                              mobile: "12",
                              tablet: "12",
                              desktop: "12",
                              styling: "primary rounded text-lg md:text-xl",
                              wrapperStyling: "!ml-1/2 !mt-0 !mb-0",
                              height: "42px",
                              disabled: _vm.disabled,
                            },
                            on: { onClickEvent: _vm.handleSubmit },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.submitButtonText) +
                                          "\n          "
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              345124742
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1323374409
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }